// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.period-selector {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 2px;
  padding: 2px 4px 2px 2px;
  border-radius: 24px;
  background: var(--surface-quaternary, #f7f7f7);
}

.period-selector__item {
  appearance: none;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 4px 8px;
  border: none;
  border-radius: 32px;
  background: transparent;
  cursor: pointer;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: var(--text-secondary);
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.period-selector__item.active {
  background: var(--color-brand);
  color: var(--text-invert);
}

.period-selector__item:disabled {
  cursor: not-allowed;
  color: var(--text-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundChart/PeriodSelector.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B;;oBAEkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".period-selector {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 2px;\n  padding: 2px 4px 2px 2px;\n  border-radius: 24px;\n  background: var(--surface-quaternary, #f7f7f7);\n}\n\n.period-selector__item {\n  appearance: none;\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 4px 8px;\n  border: none;\n  border-radius: 32px;\n  background: transparent;\n  cursor: pointer;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  text-align: center;\n  color: var(--text-secondary);\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.period-selector__item.active {\n  background: var(--color-brand);\n  color: var(--text-invert);\n}\n\n.period-selector__item:disabled {\n  cursor: not-allowed;\n  color: var(--text-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
